import { render, staticRenderFns } from "./invoiceSuccess.vue?vue&type=template&id=bed3d804&scoped=true&"
import script from "./invoiceSuccess.vue?vue&type=script&lang=js&"
export * from "./invoiceSuccess.vue?vue&type=script&lang=js&"
import style0 from "./invoiceSuccess.vue?vue&type=style&index=0&id=bed3d804&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed3d804",
  null
  
)

export default component.exports